import React from "react";
import { useTranslation } from "react-i18next";
import LandingLogo from "./LandingLogo";
import { FOOTER_LINKS } from "../landingData";

const LandingFooter = () => {
  const { t } = useTranslation("common");

  return (
    <footer>
      <div className="footer-inner">
        <LandingLogo />
        <span className="footer-copy">
          © {new Date().getFullYear()} Odoo-API. {t("All rights reserved.")}
        </span>
        <div className="footer-links">
          {FOOTER_LINKS.map(({ href, labelKey }) => (
            <a key={labelKey} href={href}>
              {t(labelKey)}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
